import React, { useState } from 'react'
import Header from './Core/Header'
import { useNavigate } from 'react-router-dom'
import { createAdmin, forgetPassword, loginAdmin, resetPassword } from '../Services/Operations/ProductAPI'
import { toast } from 'sonner'
import { useDispatch, useSelector } from 'react-redux'
import { login } from '../Redux/authSlice'
import CircularProgress from '@mui/material/CircularProgress';

const Home = () => {
  const navigate=useNavigate()
  const[formType,setFormType]=useState("login")
  const[email,setEmail]=useState("")
  const[password,setPassword]=useState("")
  const dispatch=useDispatch()
  const[load,setLoad]=useState(false)
  const[resetCose,setResetCode]=useState("")
  const[newPassword,setNewPassword]=useState("")
  

 const formFields = [
  { name: "first_name", type: "text", placeholder: "First Name" },
  { name: "last_name", type: "text", placeholder: "Last Name" },
  { name: "aadhaar_id", type: "text", placeholder: "Aadhaar ID" },
  { name: "email", type: "email", placeholder: "Email" },
  
  { name: "primary_number", type: "text", placeholder: "Phone Number" },
  { name: "password", type: "password", placeholder: "Password" },
  { name: "dob", type: "date", placeholder:'dob'},
 { name: "gender", type: "select", options: ["Male", "Female", "Other"],placeholder:"gender" },
  { name: "profile_image", type: "file",placeholder:"image" },
];

const [formData, setFormData] = useState({
  first_name: "",
  last_name: "",
  aadhaar_id: "",
  email: "",
  
  primary_number: "",
  dob: "",
  password: "",
  profile_image: null,
  gender: "",
});

const handleChange = (e) => {
  const { name, value, files } = e.target;

  if (name === "profile_image") {
    setFormData((prev) => ({
      ...prev,
      profile_image: files[0],
    }));
  } else {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
};


  const handleLogin=async()=>{
    setLoad(true)
 
    try {let data={
      email,password
    }
      const res=await loginAdmin(data)
      console.log(res);
      if(res.status===200){
        toast.success('Login Successful')
        dispatch(login({user:res.data.data.userDetails,token:JSON.stringify(res.data.data.token)}))
        navigate('/dashboard')
      }
      
    } catch (error) {
      console.log(error);
      
    }finally{
      setLoad(false)
    }
  }

  const handleRegister=async(e)=>{
    setLoad(true)
    e.preventDefault()
  try {
    console.log(formData);

    const res= await createAdmin(formData)
    console.log(res);
    
    
  } catch (error) {
    console.log(error);
    
  }finally{
    setLoad(false)
  }
  }

  const handleForgetPassword=async()=>{
    if(email===""){
      toast.info("Email field is empty")
      return
    }
    try {let data={email}
      const res=await forgetPassword(data)
      console.log(res);
      if(res.status===200 && res.data.success===true){
          toast.info("Reset toke has beee send to email")
          setFormType("reset")
      }
      
    } catch (error) {
      console.log(error);
      
    }
  }

  const handleResetPassword=async(e)=>{
      e.preventDefault();
    try {let data={reset_token:resetCose,new_password:newPassword}
      const res=await resetPassword(data)
      console.log(res);
      if(res.status===200){
        toast.success("Password reset successfully")
        setFormType('login')
      }
      
    } catch (error) {
      console.log(error);
      
    }
  }


  return (
    <div className='w-full bg-gray-500 h-full'>
     
     <section style={{marginTop:"0px"}}>
      <div
      style={{
        width: "100%",              // full width of container
        height: "100vh",            // final visible height you want
        overflow: "hidden",         // hides the cropped part
        borderRadius: "15px",       // optional, for rounded corners
        position: "relative",
      }}
    >
      <video
        src="/Assets/biotech1.mp4"   // your video file
        autoPlay
        loop
        muted
        playsInline
        style={{
          width: "100%",
          height: "100%",           // ensures scaling
          position: "absolute",
              filter: "blur(2px)",         // crop from top (adjust this value)
          objectFit: "cover",       // ensures it fills the area
        }}
      />

      <div style={{position:"absolute",zIndex:90,top:"10vh",left:"1vw",display:"flex",alignItems:"center",justifyContent:"center",gap:"30px"}}>
       <div style={{display:"flex",flexDirection:"column",width:"50%"}}> 
        <p style={{ color: "#bdbbbb", // white text
          fontSize: "58px",
          fontWeight: "bold",
          textAlign: "center",
          width:"100%",
          textShadow: `
            0 0 3px #000000ff,
            0 0 6px rgba(158, 158, 158, 1),
            0 0 9px rgba(221, 221, 221, 1)
          `,}}>Swyasthya Khata (Admin)</p>
        
        <p style={{ color: "#fff", // white text
          fontSize: "38px",
          fontWeight: "bold",
          textAlign: "center",
          width:"100%",
          textShadow: `
            0 0 3px #000000ff,
            0 0 6px rgba(158, 158, 158, 1),
            0 0 9px rgba(221, 221, 221, 1)
          `,}}>
          Connecting Care, Expertise, and Patients Seamlessly</p>
        <p style={{fontSize:"28px",fontWeight:"700",color:"white",width:"100%",textAlign:"center"}}>Empowering hospitals, doctors, and diagnostic centers with a unified platform for smarter healthcare collaboration.</p>
      </div>
      <div style={{width:"50%",height:"80vh",margin:"20px",
           backdropFilter: "blur(10px)",       // blur effect
    backgroundColor: "rgba(255, 255, 255, 0.2)", // transparent background (20% white)
    WebkitBackdropFilter: "blur(20px)",
    borderRadius:"15px",  boxShadow: "0 0 15px 3px rgba(0,0,0,0.25)",
    display:"flex",flexDirection:"column",alignItems:"center"
      }}>
        <p style={{fontSize:"30px",fontWeight:"700",textAlign:"center",color:"white",
          textShadow: `
            0 0 3px #000000ff,
            0 0 6px rgba(158, 158, 158, 1),
            0 0 9px rgba(221, 221, 221, 1)
          `,marginTop:"20px"
        }}>
          {formType==="login"?"Login to Account"
          :formType==="user"?"Create new Account"
        :"Register your Hospital"}
          </p>


       {formType==="login"?
        <div style={{margin:"30px",padding:"20px",borderRadius:"10px",backgroundColor:"transparent",
           display:"flex",flexDirection:"column",alignItems:"center"
        }}>
         <label>
          <p style={{fontSize:"18px",fontWeight:"600"}}>Email</p>
          <input type='email' style={{
            width:'200px',
            padding:"4px",
            border:"1px solid black",
            borderRadius:"5px",
            fontSize:"18px",
            outline:"none"
          }}
          placeholder='Enter email' value={email} onChange={(e)=>setEmail(e.target.value)}/></label>
          <label>
            <p style={{fontSize:"18px",fontWeight:"600"}}>Password</p>
          <input  type='password' style={{
            width:'200px',
            padding:"4px",
            border:"1px solid black",
            borderRadius:"5px",
            fontSize:"18px",
            outline:"none"
          }}
          placeholder='Enter password' value={password} onChange={(e)=>setPassword(e.target.value)}/></label>
          <button onClick={()=>handleLogin()}
          style={{backgroundColor:"#3279fdff",color:"white",fontWeight:"bold",
            padding:"6px",borderRadius:"8PX",margin:"12PX",cursor:"pointer",fontSize:"18px"
          }}>{load?<CircularProgress color="inherit" />:"Login"}</button>
          
          <p style={{fontSize:"14px",color:"gray"}}>
            <span onClick={()=>handleForgetPassword()}
            style={{color:"#d41010",cursor:"pointer"}}>Forget Password?</span> </p>
        </div>
      :formType==="user"? // verify if user is present or not
       <form style={{margin:"30px",padding:"20px",borderRadius:"10px",backgroundColor:"transparent",
           display:"flex",flexDirection:"column",alignItems:"center"
        }} onSubmit={handleRegister}>
          
         
         
  {formFields.map((field) => {
    if (field.type === "select") {
      return (
        <label style={{padding:"6px",display:"flex",justifyContent:"space-between",width:"100%"}}>
        <span style={{fontWeight:"600",margin:"0px 6px"}}>{field.placeholder}:</span>
        <select name={field.name} onChange={handleChange} key={field.name}>
          <option value="">Select {field.name}</option>
          {field.options.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
        </label>
      );
    }

    return (
      <label style={{padding:"6px",display:"flex",justifyContent:"space-between",width:"100%"}}>
        <span style={{fontWeight:"600",margin:"0px 6px"}}>{field.placeholder}:</span>
      <input
        key={field.name}
        type={field.type}
        name={field.name}
        placeholder={field.placeholder}
        onChange={handleChange}
        style={{border:"0.3px solid black",padding:"3px",outline:"none",borderRadius:"3px",}}
      />
      </label>
    );
  })}

 
  <button onClick={()=>handleLogin()} type="submit"
          style={{backgroundColor:"#3279fdff",color:"white",fontWeight:"bold",
            padding:"6px",borderRadius:"8PX",margin:"12PX",cursor:"pointer",fontSize:"18px"
          }}>{load?<CircularProgress color="inherit" />:"Register"}</button>
</form>
          
         
       
        : 
        <form style={{margin:"30px",padding:"20px",borderRadius:"10px",backgroundColor:"transparent",
           display:"flex",flexDirection:"column",alignItems:"center",gap:"6px"
        }}>
        
            <label>
          <p style={{fontSize:"18px",fontWeight:"600"}}>Reset Code</p>
          <input type='password' style={{
            width:'200px',
            padding:"4px",
            border:"1px solid black",
            borderRadius:"5px",
            fontSize:"18px",
            outline:"none"
          }}
          placeholder='Enter reset token' value={resetCose} onChange={(e)=>setResetCode(e.target.value)}/></label>
          <label>
            <p style={{fontSize:"18px",fontWeight:"600"}}>New Password</p>
          <input  type='password' style={{
            width:'200px',
            padding:"4px",
            border:"1px solid black",
            borderRadius:"5px",
            fontSize:"18px",
            outline:"none"
          }}
          placeholder='Enter new password' value={newPassword} onChange={(e)=>setNewPassword(e.target.value)}/></label>
          <button type="button" onClick={handleResetPassword}
          style={{backgroundColor:"#3279fdff",color:"white",fontWeight:"bold",
            padding:"6px",borderRadius:"8PX",margin:"12PX",cursor:"pointer",fontSize:"18px"
          }}>{load?<CircularProgress color="inherit" />:"Reset"}</button>
        </form> 
      }

      </div>
      </div>
    </div>

     </section>

      
    </div>
  )
}

export default Home
